import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIgloo,
  faBlog,
  faEnvelope,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const Navmenu = () => {
  return (
    <nav className="navbar" style={{ transition: "all 600ms ease" }}>
      <ul style={{ transition: "width 600ms ease" }}>
        <li>
          <AniLink cover to="/" direction="right" duration={2} bg="#193b6e">
            <FontAwesomeIcon icon={faIgloo} /> <span>Me</span>
          </AniLink>
        </li>
        <li>
          <AniLink cover to="/portfolio"  direction="right" duration={2} bg="#193b6e">
            <FontAwesomeIcon icon={faBriefcase} />
            <span style={{ paddingRight: 20 }}>Portfolio</span>
          </AniLink>
        </li>
        <li>
          <AniLink cover to="/contact"  direction="right" duration={2} bg="#193b6e">
            <FontAwesomeIcon icon={faEnvelope} />
            <span>Contact</span>
          </AniLink>
        </li>
        <li>
          <AniLink cover to="/blog" direction="right" duration={2} bg="#193b6e">
            <FontAwesomeIcon icon={faBlog} />
            <span>Blog</span>
          </AniLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navmenu;
